import { render } from "./SignUpFormNew.vue?vue&type=template&id=a739674e&scoped=true"
import script from "./SignUpFormNew.vue?vue&type=script&lang=js"
export * from "./SignUpFormNew.vue?vue&type=script&lang=js"

import "./SignUpFormNew.vue?vue&type=style&index=0&id=a739674e&lang=scss&scoped=true"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a739674e"]])

export default __exports__